import React from 'react';

import BreakdownDetailsModal from 'common/activeElements/modals/BreakdownDetailsModal';
import ManageExtraActivity from 'common/activeElements/modals/ManageExtraActivity';
import { MANAGE_EXTRA_ACTIVITY_MODES } from 'common/activeElements/modals/ManageExtraActivity/const';
import ModalDeleteExtraActivity from 'common/activeElements/modals/ModalDeleteExtraActivity';
import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import WorkAssignmentDetails from 'common/activeElements/sidebars/WorkAssignmentDetails';

export const getManageExtraActivitySuccessHandler = (mode, store) =>
	mode === MANAGE_EXTRA_ACTIVITY_MODES.manage
		? store.refetchCurrentRide
		: store.mergeMutatedAssignmentSequence;

export const getRideDetailsActiveElementConfig = (store) => [
	{
		name: SIDEBAR_NAMES.waDetails,
		Component: (props) => <WorkAssignmentDetails {...props} />,
	},
	{
		name: MODAL_NAMES.manageExtraActivity,
		Component: (props) => (
			<ManageExtraActivity
				{...props}
				baseTimezone={store.selectedTimezone?.value ?? store.stationTimezone?.value}
				onActionSuccess={getManageExtraActivitySuccessHandler(props.mode, store)}
			/>
		),
	},
	{
		name: MODAL_NAMES.deleteExtraActivity,
		Component: (props) => <ModalDeleteExtraActivity {...props} />,
	},
	{
		name: MODAL_NAMES.breakdownDetails,
		Component: (props) => <BreakdownDetailsModal {...props} />,
	},
];
